var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"component-container"}},[_c('div',{attrs:{"id":"redirect"}},[_c('b-spinner',{staticStyle:{"width":"5rem","height":"5rem","position":"absolute"},attrs:{"variant":"primary","type":"grow"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v(" "+_vm._s(_vm.$t('redirect')))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb47e83e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Redirect.vue
// module id = null
// module chunks = 